<form novalidate #currentForm="ngForm">
  <div class="endpoints-container">
    <div class="section-container">
      <div class="section-label">Endpoints</div>
      <div class="endpoint-section">
        <nrwl-agent-picker
          [testType]="'bert'"
          [originatorDevice]="selectedOriginator"
          [destinationDevice]="selectedDestination"
          [editMode]="editMode"
          [testMode]="testMode"
          [loopbackType]="selectedLoopbackTypes"
          [showTestMode]="false"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
        <div class="agent-info">
          <div class="orginator-info">
            <div class="orginator-content" *ngIf="showOrginatorDetails">
              <div class="section-data">
                <div class="group" *ngIf="showFormField(configMapping.TRANSMIT_INTERFACE)">
                  <div class="label">Transmit interface</div>
                  <mat-select
                    class="option-list"
                    #txInterfaceInput="ngModel"
                    [(ngModel)]="formField.txInterface"
                    name="txInterface"
                    (selectionChange)="onTxInterfaceChange()"
                    required
                  >
                    <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                      tx.name
                    }}</mat-option>
                  </mat-select>
                </div>
                <div class="tx-image" *ngIf="showFormField(configMapping.TRANSMIT_INTERFACE)">
                  <img [src]="txTypeImage" />
                </div>
                <div
                  class="group"
                  *ngIf="
                    showFormField(configMapping.SRC_MAC_ADDRESS) ||
                    showFormField(configMapping.SRC_EQUIPMENT_MAC)
                  "
                >
                  <div class="label">
                    MAC address
                    <i
                      class="mdi mdi-help-circle-outline"
                      matTooltip="{{ formTooltip.srcMacAddress }}"
                    ></i>
                  </div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcMacAddress"
                    [(ngModel)]="formField.srcMacAddress"
                    #srcMacAddressInput="ngModel"
                    (ngModelChange)="onSourceMacAddressChange()"
                    disabled="true"
                    class="disable"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcMacAddressInput.invalid &&
                      (srcMacAddressInput.dirty || srcMacAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcMacAddressInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcMacAddressInput.errors?.pattern"
                      >Mac Address is not a valid</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="section-data" *ngIf="showFormField(configMapping.SRC_TEST_IP_ADDRESS)">
                <div class="group" *ngIf="showFormField(configMapping.DEFINED_ADDRESS)">
                  <div class="label">Defined address using</div>
                  <mat-select
                    class="option-list"
                    #definedAddressInput="ngModel"
                    [(ngModel)]="formField.definedAddress"
                    name="definedAddress"
                    (selectionChange)="onDefinedAddressChange()"
                    required
                  >
                    <ng-container *ngFor="let type of definedAddressTypes">
                      <mat-option *ngIf="type.enabled" [value]="type.value">{{
                        type.name
                      }}</mat-option>
                    </ng-container>
                  </mat-select>
                </div>
                <div class="group" *ngIf="!dhcpEnabled">
                  <div class="label">
                    IP address
                    <span *ngIf="formTooltip?.srcIpAddress"
                      ><i
                        class="mdi mdi-help-circle-outline"
                        matTooltip="{{ formTooltip.srcIpAddress }}"
                      ></i
                    ></span>
                  </div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcIpAddress"
                    class="width-200"
                    [(ngModel)]="formField.srcIpAddress"
                    #srcIpAddressInput="ngModel"
                    (ngModelChange)="onSourceIpAddressChange()"
                    [disabled]="
                      layer3Enabled ? !formField.srcEditLayer3IP : !formField.srcEditLayer2IP
                    "
                    [ngClass]="{
                      disable: layer3Enabled
                        ? !formField.srcEditLayer3IP
                        : !formField.srcEditLayer2IP
                    }"
                    [pattern]="validIPRegex"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcIpAddressInput.invalid &&
                      (srcIpAddressInput.dirty || srcIpAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcIpAddressInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcIpAddressInput.errors?.pattern">{{
                      ipErrorMsg
                    }}</mat-error>
                  </div>
                </div>
              </div>
              <div
                class="section-data"
                *ngIf="showFormField(configMapping.SRC_SUBNET) && layer3Enabled && !dhcpEnabled"
              >
                <div class="group">
                  <div class="label">Subnet mask/prefix *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcSubnet"
                    [(ngModel)]="formField.srcSubnet"
                    #srcSubnetInput="ngModel"
                    [disabled]="!formField.srcEditLayer3Subnet"
                    [ngClass]="{
                      disable: !formField.srcEditLayer3Subnet
                    }"
                    (ngModelChange)="onSourceSubnetChange()"
                    [pattern]="subnetRegEx"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcSubnetInput.invalid && (srcSubnetInput.dirty || srcSubnetInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcSubnetInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcSubnetInput.errors?.pattern"
                      >Subnet is not valid</mat-error
                    >
                  </div>
                </div>
                <div
                  class="group"
                  *ngIf="showFormField(configMapping.SRC_GATEWAY) && layer3Enabled && !dhcpEnabled"
                >
                  <div class="label">Gateway address *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcGateway"
                    [(ngModel)]="formField.srcGateway"
                    #srcGatewayInput="ngModel"
                    [disabled]="!formField.srcEditLayer3Subnet"
                    [ngClass]="{
                      disable: !formField.srcEditLayer3Subnet
                    }"
                    (ngModelChange)="onSourceGatewayChange()"
                    [pattern]="validIPRegex"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcGatewayInput.invalid && (srcGatewayInput.dirty || srcGatewayInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcGatewayInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcGatewayInput.errors?.pattern"
                      >Gateway must be set to a valid address</mat-error
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="destination-info" *ngIf="showDestinationDetails">
            <div class="section-data">
              <div class="group" *ngIf="layer2Enabled && isJmepAsLb">
                <div class="label">Transmit interface</div>
                <mat-select
                  class="option-list"
                  #destTxInterfaceInput="ngModel"
                  [(ngModel)]="formField.destTxInterface"
                  name="destTxInterface"
                  (selectionChange)="onDestTxInterfaceChange()"
                  required
                >
                  <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                    tx.name
                  }}</mat-option>
                </mat-select>
              </div>
              <div class="tx-image" *ngIf="layer2Enabled && isJmepAsLb">
                <img [src]="destTxTypeImage" />
              </div>

              <div
                class="group"
                *ngIf="showFormField(configMapping.USE_ARP) && layer3Enabled && ipType === 'ipv4'"
              >
                <div class="label">Use ARP to learn MAC</div>
                <mat-select
                  class="option-list width-75"
                  #useArpInput="ngModel"
                  [(ngModel)]="formField.useArp"
                  [disabled]="!formField.suppressLoop"
                  name="useArp"
                  (selectionChange)="onArpChange()"
                  required
                >
                  <mat-option *ngFor="let arp of useArpTypes" [value]="arp.value">{{
                    arp.name
                  }}</mat-option>
                </mat-select>
              </div>
              <div class="group" *ngIf="layer3Enabled ? this.formField.destShowMacLayer3 : true">
                <div class="label">MAC address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="destMacAddress"
                  [(ngModel)]="formField.destMacAddress"
                  #destMacAddressInput="ngModel"
                  (ngModelChange)="onDestinationMacAddressChange()"
                  [pattern]="macRegex"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destMacAddressInput.invalid &&
                    (destMacAddressInput.dirty || destMacAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destMacAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destMacAddressInput.errors?.pattern"
                    >Mac Address is not a valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div
              class="section-data"
              *ngIf="
                (layer2Enabled ? this.formField.destShowIpLayer2 : true) ||
                (layer3Enabled && isJmepAsLb)
              "
            >
              <div class="group" *ngIf="isJmepAsLb">
                <div class="label">Defined address using</div>
                <mat-select
                  class="option-list"
                  #destDefinedAddressInput="ngModel"
                  [(ngModel)]="formField.destDefinedAddress"
                  name="destDefinedAddress"
                  (selectionChange)="onDestDefinedAddressChange()"
                  required
                >
                  <ng-container *ngFor="let type of destDefinedAddressTypes">
                    <mat-option *ngIf="type.enabled" [value]="type.value">{{
                      type.name
                    }}</mat-option>
                  </ng-container>
                </mat-select>
              </div>

              <div class="group">
                <div class="label">IP address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  class="width-200"
                  name="destIpAddress"
                  [(ngModel)]="formField.destIpAddress"
                  #destIpAddressInput="ngModel"
                  (ngModelChange)="onDestinationIpAddressChange()"
                  [pattern]="validIPRegex"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destIpAddressInput.invalid &&
                    (destIpAddressInput.dirty || destIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destIpAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destIpAddressInput.errors?.pattern">{{ ipErrorMsg }}</mat-error>
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group" *ngIf="showFormField(configMapping.SUPPRESS_LOOP_COMMANDS)">
                <div class="label">Loop up device</div>
                <mat-select
                  class="option-list width-75"
                  #supressLoopIntervalInput="ngModel"
                  [(ngModel)]="formField.suppressLoop"
                  name="suppressLoop"
                  (selectionChange)="onSuppressLoopChange()"
                  required
                >
                  <mat-option *ngFor="let supress of suppressLoopTypes" [value]="supress.value">{{
                    supress.name
                  }}</mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div class="setup-manual" *ngIf="!showDestinationDetails && testMode === 'loopback'">
            <a href="#" (click)="setManualDestAddress($event)">Setup manually</a>
          </div>
        </div>
      </div>
    </div>

    <div class="section-container" *ngIf="showFormField(configMapping.VLAN_CONFIG)">
      <div class="section-label">VLAN</div>
      <div class="section-data">
        <div class="group">
          <div class="label">VLAN Config</div>
          <mat-select
            class="option-list"
            #vlanConfigInput="ngModel"
            [(ngModel)]="formField.vlanConfig"
            name="vlanConfig"
            (selectionChange)="onVlanConfigChange()"
            required
          >
            <mat-option *ngFor="let vlan of vlanConfigTypes" [value]="vlan.value">{{
              vlan.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="label">{{ formField.vlanConfig === 'q_in_q' ? 'S-VLAN *' : 'VLAN *' }}</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="svlan"
            class="width-75"
            [(ngModel)]="formField.svlan"
            #sVlanInput="ngModel"
            (ngModelChange)="onSVlanChange()"
            min="1"
            max="4094"
            required
          />
          <div class="error" *ngIf="sVlanInput.invalid && (sVlanInput.dirty || sVlanInput.touched)">
            <mat-error *ngIf="sVlanInput.errors.required">Required</mat-error>
            <mat-error *ngIf="sVlanInput.errors?.min || sVlanInput.errors?.max"
              >Should be 1 to 4094</mat-error
            >
          </div>
        </div>
        <div
          class="group"
          *ngIf="showFormField(configMapping.ETHER_TYPE) && formField.vlanConfig !== 'untagged'"
        >
          <div class="label">Ethertype</div>
          <mat-select
            class="option-list width-75"
            #etherTypeInput="ngModel"
            [(ngModel)]="formField.etherType"
            name="etherType"
            (selectionChange)="onEtherTypeChange()"
            required
          >
            <mat-option *ngFor="let ether of etherTypesData" [value]="ether.value">{{
              ether.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField.vlanConfig === 'q_in_q'">
          <div class="label">C-VLAN *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="cvlan"
            class="width-75"
            [(ngModel)]="formField.cvlan"
            #cVlanInput="ngModel"
            (ngModelChange)="onCVlanChange()"
            min="1"
            max="4094"
            required
          />
          <div class="error" *ngIf="cVlanInput.invalid && (cVlanInput.dirty || cVlanInput.touched)">
            <mat-error *ngIf="cVlanInput.errors?.required">Required</mat-error>
            <mat-error *ngIf="cVlanInput.errors?.min || cVlanInput.errors?.max"
              >Should be 1 to 4094</mat-error
            >
          </div>
        </div>
        <div
          class="group"
          *ngIf="showFormField(configMapping.CVLAN_ETHER_TYPE) && formField.vlanConfig === 'q_in_q'"
        >
          <div class="label">CLVAN Ethertype</div>
          <mat-select
            class="option-list width-75"
            #cvlanEtherInput="ngModel"
            [(ngModel)]="formField.cVlanEtherType"
            name="cVlanEtherType"
            (selectionChange)="onCVlanEtherTypeChange()"
            required
          >
            <mat-option *ngFor="let ether of cVlanEtherTypeData" [value]="ether.value">{{
              ether.name
            }}</mat-option>
          </mat-select>
        </div>
        <div
          class="group"
          *ngIf="showFormField(configMapping.DEI_ENABLE) && formField.vlanConfig === 'q_in_q'"
        >
          <div class="label">DEI enabled</div>
          <mat-select
            class="option-list width-75"
            #deiEnableInput="ngModel"
            [(ngModel)]="formField.deiEnable"
            name="deiEnable"
            (selectionChange)="onDeiEnableChange()"
            required
          >
            <mat-option *ngFor="let dei of deiEnableData" [value]="dei.value">{{
              dei.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="showFormField(configMapping.VERIFY_PRIORITY)">
          <div class="label width-140">Verify VLAN Priority</div>
          <mat-select
            class="option-list width-75"
            #verifyVlanInput="ngModel"
            [(ngModel)]="formField.vlanPriority"
            [disabled]="formField.vlanConfig === 'untagged'"
            name="verifyVlan"
            (selectionChange)="onVlanPriorityChange()"
            required
          >
            <mat-option *ngFor="let vlan of verifyVlanData" [value]="vlan.value">{{
              vlan.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="section-container" *ngIf="showFormField(configMapping.SWAP_MAC_ADDRESS)">
      <div class="section-label">Advanced</div>
      <div class="section-data">
        <div class="group" *ngIf="showFormField(configMapping.SWAP_MAC_ADDRESS)">
          <div class="label width-140">Swap MAC addresses</div>
          <mat-select
            class="option-list width-75"
            #swapMacInput="ngModel"
            [(ngModel)]="formField.swapMac"
            name="swapMac"
            (selectionChange)="onSwapMacChange()"
            required
          >
            <mat-option *ngFor="let swap of swapMacTypes" [value]="swap.value">{{
              swap.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
</form>
